import { LinariaClassName } from '@linaria/core';
import React, { FC } from 'react';

export const CopyIcon: FC<{ className?: string | LinariaClassName; color?: string }> = ({ className = '', color = '#667085' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
      <g clipPath="url(#clip0_899_10)">
        <path
          d="M5.33333 10.6667V12.5333C5.33333 13.2801 5.33333 13.6534 5.47866 13.9387C5.60649 14.1895 5.81046 14.3935 6.06135 14.5214C6.34656 14.6667 6.71993 14.6667 7.46667 14.6667H12.5333C13.2801 14.6667 13.6534 14.6667 13.9387 14.5214C14.1895 14.3935 14.3935 14.1895 14.5213 13.9387C14.6667 13.6534 14.6667 13.2801 14.6667 12.5333V7.46668C14.6667 6.71994 14.6667 6.34657 14.5213 6.06136C14.3935 5.81047 14.1895 5.6065 13.9387 5.47867C13.6534 5.33334 13.2801 5.33334 12.5333 5.33334H10.6667M3.46667 10.6667H8.53333C9.28007 10.6667 9.65344 10.6667 9.93865 10.5214C10.1895 10.3935 10.3935 10.1895 10.5213 9.93866C10.6667 9.65345 10.6667 9.28008 10.6667 8.53334V3.46668C10.6667 2.71994 10.6667 2.34657 10.5213 2.06136C10.3935 1.81047 10.1895 1.6065 9.93865 1.47867C9.65344 1.33334 9.28007 1.33334 8.53333 1.33334H3.46667C2.71993 1.33334 2.34656 1.33334 2.06135 1.47867C1.81046 1.6065 1.60649 1.81047 1.47866 2.06136C1.33333 2.34657 1.33333 2.71994 1.33333 3.46668V8.53334C1.33333 9.28008 1.33333 9.65345 1.47866 9.93866C1.60649 10.1895 1.81046 10.3935 2.06135 10.5214C2.34656 10.6667 2.71993 10.6667 3.46667 10.6667Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_899_10">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
